import type { ReactNode } from 'react';
import * as React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

type FontOption = {
  name: string;
  value: string;
  label: string;
};

const fontOptions: FontOption[] = [
  { name: 'Noto Sans KR', value: "'Noto Sans KR', sans-serif", label: 'Noto Sans KR' },
  { name: 'Pretendard', value: "'Pretendard', sans-serif", label: 'Pretendard' },
  { name: 'IBM Plex Sans KR', value: "'IBM Plex Sans KR', sans-serif", label: 'IBM Plex Sans KR' },
  { name: 'Spoqa Han Sans', value: "'Spoqa Han Sans Neo', sans-serif", label: 'Spoqa Han Sans' },
  { name: 'Gowun Batang', value: "'Gowun Batang', serif", label: 'Gowun Batang' },
  { name: 'Nanum Myeongjo', value: "'Nanum Myeongjo', serif", label: 'Nanum Myeongjo' },
];

type FontContextType = {
  currentFont: FontOption;
  setFont: (font: FontOption) => void;
  fontOptions: FontOption[];
};

const FontContext = createContext<FontContextType | undefined>(undefined);

export const FontProvider = ({ children }: { children: ReactNode }) => {
  const [currentFont, setCurrentFont] = useState<FontOption>(fontOptions[2]);

  useEffect(() => {
    document.documentElement.style.setProperty('--font-body', currentFont.value);
  }, [currentFont]);

  const setFont = (font: FontOption) => {
    setCurrentFont(font);
  };

  return <FontContext.Provider value={{ currentFont, setFont, fontOptions }}>{children}</FontContext.Provider>;
};

export const useFont = () => {
  const context = useContext(FontContext);
  if (!context) {
    throw new Error('useFont must be used within a FontProvider');
  }
  return context;
};
